import Logger from '../libs/Logger';

const log = new Logger('Observer');
const debug = false;

export default class Observer {
  constructor(selector, margin, conf, cb) {
    const observablesSelector = selector || '.observe';
    const observables = document.querySelectorAll(observablesSelector);
    debug && console.log('Observer', 'observables', observables);

    if (!window.IntersectionObserver) {
      log.warn('IntersectionObserver not supported');
      for (const el of observables) {
        cb(el);
      }
    } else {
      //log.d('IntersectionObserver supported');
      log.debug('IntersectionObserver supported');
      const rootMargin = margin || Math.floor(window.outerHeight / 3);
      this.observer = new IntersectionObserver(cb, conf || {
        root: null,
        rootMargin: `${rootMargin}px 0px`,
        threshold: 0.01
      });

      for (const observable of observables) {
        this.observer.observe(observable);
      }
    }
  }

  disconnect() {
    debug && console.log('Observer disconnect');

    this.observer.disconnect();
  }
}
